"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CitoServiceClient = void 0;
const AxiosHttpRequest_1 = require("../core/AxiosHttpRequest");
const AccessService_1 = require("./services/AccessService");
const CertificateService_1 = require("./services/CertificateService");
const CitoModulesService_1 = require("./services/CitoModulesService");
const PingService_1 = require("./services/PingService");
const SignInService_1 = require("./services/SignInService");
class CitoServiceClient {
    constructor(config, HttpRequest = AxiosHttpRequest_1.AxiosHttpRequest) {
        var _a, _b, _c, _d;
        this.request = new HttpRequest({
            BASE: (_a = config === null || config === void 0 ? void 0 : config.BASE) !== null && _a !== void 0 ? _a : '',
            VERSION: (_b = config === null || config === void 0 ? void 0 : config.VERSION) !== null && _b !== void 0 ? _b : '1',
            WITH_CREDENTIALS: (_c = config === null || config === void 0 ? void 0 : config.WITH_CREDENTIALS) !== null && _c !== void 0 ? _c : false,
            CREDENTIALS: (_d = config === null || config === void 0 ? void 0 : config.CREDENTIALS) !== null && _d !== void 0 ? _d : 'include',
            TOKEN: config === null || config === void 0 ? void 0 : config.TOKEN,
            USERNAME: config === null || config === void 0 ? void 0 : config.USERNAME,
            PASSWORD: config === null || config === void 0 ? void 0 : config.PASSWORD,
            HEADERS: config === null || config === void 0 ? void 0 : config.HEADERS,
            ENCODE_PATH: config === null || config === void 0 ? void 0 : config.ENCODE_PATH,
            HTTPS_AGENT: config === null || config === void 0 ? void 0 : config.HTTPS_AGENT,
            FALLBACK_BASE_URL: config === null || config === void 0 ? void 0 : config.FALLBACK_BASE_URL,
            REQUEST_TIMEOUT: config === null || config === void 0 ? void 0 : config.REQUEST_TIMEOUT,
        });
        this.access = new AccessService_1.AccessService(this.request);
        this.certificate = new CertificateService_1.CertificateService(this.request);
        this.citoModules = new CitoModulesService_1.CitoModulesService(this.request);
        this.ping = new PingService_1.PingService(this.request);
        this.signIn = new SignInService_1.SignInService(this.request);
    }
}
exports.CitoServiceClient = CitoServiceClient;
